import {useSetAtom} from 'jotai';
import {useEffect} from 'react';
import {Splash} from '@/components/Splash';
import {useChannelTalk, useUplusUserAgent} from '@/hooks';
import {useGA4WithParams} from '@/hooks/tracking';
import {mapAgentTypeAtom} from '@/map/atom';
import {Map as MapComponent} from '@/map/components/MobileMaps';
import AndroidBackHandler from '@/map/components/MobileMaps/AndroidBackHandler';
import {MobileMapAgent} from '@/map/enums';
import {IS_DEV_SERVER} from '@/router';
import {FullContainer} from '@/styled-components';
import {useQueryClient} from '@tanstack/react-query';

const MAP_AGENT = MobileMapAgent.lgup;

const LGUPlusMap = () => {
  const {hideChannelTalk, showChannelTalk} = useChannelTalk();
  const isUplusApp = useUplusUserAgent();

  useEffect(() => {
    hideChannelTalk();

    return () => {
      showChannelTalk();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!IS_DEV_SERVER) {
    if (isUplusApp === null) {
      return <Splash />;
    } else if (!isUplusApp) {
      return (
        <div>
          잘못된 접근입니다. <br />
          {navigator.userAgent}
        </div>
      );
    }
  }

  return <Page agent={MAP_AGENT} />;
};

const Page = ({agent}: {agent: MobileMapAgent}) => {
  const tracking = useGA4WithParams();
  const setMapAgent = useSetAtom(mapAgentTypeAtom);
  const queryClient = useQueryClient();

  useEffect(() => {
    return () => {
      queryClient.removeQueries({queryKey: ['map']});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setMapAgent(agent);
    tracking('map_open', {
      agent,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FullContainer>
      <AndroidBackHandler />
      <MapComponent agent={agent} />
    </FullContainer>
  );
};

export default LGUPlusMap;
